import React from "react";
import "./App.css";
import productImage from "./WhatsApp Image 2025-12-22 at 11.27.57 PM (1) (1).png";

const AboutOmAgroFood = () => {
  return (
    <>
    <head>
        <title>OM AGRO FOODS | Premium Kesar Mango Pulp Manufacturer & Supplier</title>

        <meta
          name="description"
          content="OM AGRO FOODS offers premium quality Kesar Mango Pulp made from handpicked mangoes. Ideal for aamras, ice creams, desserts, beverages, and bulk supply."
        />

        <meta
          name="keywords"
          content="About om agro foods, Kesar Mango Pulp, Mango Pulp Manufacturer, Mango Pulp Supplier, OM AGRO FOODS, buy natural mango pulp, om agro foods, natural mango pulp, mango pulp, Aamras Pulp, Bulk Mango Pulp"
        />

        <link rel="canonical" href="https://omagrofoods.vercel.app/" />

        <link rel="icon" type="image/png" href="%PUBLIC_URL%/site-logo-omagrofood.png" sizes="48x48" />
        <link rel="icon" type="image/png" href="%PUBLIC_URL%/site-logo-omagrofood.png" sizes="96x96" />
        <link rel="icon" type="image/png" href="%PUBLIC_URL%/site-logo-omagrofood.png" sizes="192x192" />
        <link rel="shortcut icon" type="image/png" href="%PUBLIC_URL%/site-logo-omagrofood.png" />
        <link rel="apple-touch-icon" type="image/png" href="%PUBLIC_URL%/site-logo-omagrofood.png" />
        <meta property="og:title" content="OM AGRO FOODS | Premium Kesar Mango Pulp" />
        <meta
          property="og:description"
          content="Premium quality Kesar Mango Pulp with rich taste, aroma, and natural sweetness. Available for retail and bulk orders."
        />
        <meta property="og:image" content={productImage} />
        <meta property="og:url" content="https://omagrofoods.vercel.app/" />
        <meta property="og:type" content="website" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="OM AGRO FOODS | Premium Mango Pulp" />
        <meta
          name="twitter:description"
          content="Premium Kesar Mango Pulp supplier for homes, hotels, and food industries."
        />
        <meta name="twitter:image" content={productImage} />
      </head>
    <div className="about-container">
      <div className="about-hero">
        <div className="about-hero-text">
          <h1>About OM AGRO FOOD</h1>
          <p>
            OM AGRO FOOD is a trusted name in the agro food industry, committed
            to delivering high-quality, nutritious, and hygienically processed
            food products to customers across India and beyond.
          </p>
        </div>
        <div className="about-hero-image">
          <img
            src="omagrofood-mango (1).png"
            alt="Agro Food"
          />
        </div>
      </div>

      <div className="about-section">
        <h2>Who We Are</h2>
        <p>
          Founded with a vision to provide pure and natural food products, OM
          AGRO FOOD focuses on sourcing the finest raw materials directly from
          farmers. Our modern processing techniques ensure freshness, taste,
          and nutritional value in every product we deliver.
        </p>
      </div>

      <div className="about-cards">
        <div className="about-card">
          <img
            src="image.png"
            alt="Quality Products"
          />
          <h3>Premium Quality</h3>
          <p>
            We follow strict quality control standards to ensure that every
            product meets international food safety norms.
          </p>
        </div>

        <div className="about-card">
          <img
            src="Juice-Plant.jpg"
            alt="Modern Processing"
          />
          <h3>Modern Processing</h3>
          <p>
            Advanced machinery and hygienic processing units help us maintain
            consistency, purity, and superior taste.
          </p>
        </div>

        <div className="about-card">
          <img
            src="unnamed.jpg"
            alt="Farmer Support"
          />
          <h3>Farmer Support</h3>
          <p>
            We work closely with local farmers, ensuring fair prices and
            sustainable agricultural practices.
          </p>
        </div>
      </div>

      <div className="about-mission">
        <div className="mission-box">
          <h2>Our Mission</h2>
          <p>
            To deliver healthy, safe, and high-quality agro food products while
            supporting farmers and promoting sustainable growth.
          </p>
        </div>

        <div className="mission-box">
          <h2>Our Vision</h2>
          <p>
            To become a leading agro food brand known for trust, quality, and
            innovation in the global market.
          </p>
        </div>
      </div>
    </div>
    </>
  );
};

export default AboutOmAgroFood;
